// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'

import {
  Spinner,
  SvgIcon
} from '../../'

import { decodeBase64 } from '../../../utils'

import { AccountContext } from '../../../context'

const QUERY_FILERELATIONS = gql`
  query($employerId: UUID!, $startOfDay: DateTime!, $endOfDay: DateTime!) {
    filerelations(createdAt_Gte: $startOfDay, createdAt_Lte: $endOfDay, file_Filetype_Name: "Employee Payslip", objectId: $employerId, contentType_Model: "employer", orderBy: "-created_at") {
      totalCount
      edges {
        node {
          id
          file {
            id
            asset
          }
        }
      }
    }
  }
`


export const PayslipsUploaded = ({ payrollCycleDate }) => (
  <AccountContext.Consumer>
    {({ currentAccountId: employerId }) => (
      <Query
        query={QUERY_FILERELATIONS}
        variables={{
          employerId: decodeBase64(employerId),
          startOfDay: moment.utc(payrollCycleDate).startOf('day'),
          endOfDay: moment.utc(payrollCycleDate).endOf('day')
        }}>

        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner size='small' className='slds-is-relative' />
          }

          if (error) {
            return (
              <SvgIcon
                variant='utility'
                symbol='warning'
                colour='error'
                size='small'
                title={`Error fetching data necessary to display number of payslips loaded on ${moment(payrollCycleDate).format('DD MMM YYYY')}`}
              />
            )
          }

          const numberOfFilesUploaded = data.filerelations.totalCount > 0
            ? data.filerelations.edges.filter(({ node: relation }) => (
                relation.file.asset.endsWith('.png')
              )).length
            : 0

          return numberOfFilesUploaded
        }}
      </Query>
    )}
  </AccountContext.Consumer>
)

PayslipsUploaded.propTypes = {
  payrollCycleDate: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/messageplus/dashboard-reporting/PayslipsUploaded.js